import type { FC } from 'react'
import PriorityIcon from './PriorityIcon'
import { Box, Button } from '@mui/material'
import { BRAND, GREY } from '~/shared/lib/theme'

// The flag's fill, indexed by the numeric priority the API stores: on hover, and when disabled.
const HOVER_FILL: Record<number, string> = { 0: GREY[300], 1: BRAND.dark, 2: '#AF0400' }
const DISABLED_FILL: Record<number, string> = { 0: GREY[100], 1: '#FFCCA9', 2: '#FF9B99' }

interface PriorityToggleProps {
  priority: number
  onChange: (e: React.MouseEvent, priority: number) => void
  disabled?: boolean
}

const PriorityToggle: FC<PriorityToggleProps> = props => {
  const { onChange, priority, disabled } = props

  return (
    <Box
      sx={{
        '& button': {
          minWidth: '20px',
          padding: 0,
          marginRight: '6px',
        },
      }}
    >
      <Button
        size="small"
        onClick={e => onChange(e, (priority + 1) % 3)}
        disabled={disabled}
        sx={
          disabled
            ? {
                '& svg > path:nth-of-type(1)': {
                  fill: DISABLED_FILL[priority] ?? GREY[100],
                },
              }
            : {
                '& svg:hover > path:nth-of-type(1)': {
                  fill: HOVER_FILL[priority] ?? GREY[300],
                },
              }
        }
      >
        <PriorityIcon level={priority} variant="view" />
      </Button>
    </Box>
  )
}

export default PriorityToggle
